<script>
import Layout from '@layouts/default'
import VehicleSearch from '@components/vehicle-search'

export default {
  page: {
    title: 'AutoCheck v Bargain Reports | AutoCheck.com',
    meta: [
      { name: 'description', content: 'autocheck v bargain reports' },
      { name: 'keywords', content: 'autocheck, bargain, reports' },
    ],
    link: [
      {
        rel: 'canonical',
        href: 'https://www.autocheck.com/vehiclehistory/autocheck-vs-bargain',
      },
    ],
  },
  components: { Layout, VehicleSearch },
}
</script>

<template>
  <Layout>
    <div class="row mt-4 mb-4">
      <div class="col-md-9 col-12">
        <h1>AutoCheck vs. Bargain Reports</h1>
        <hr />
        <div class="sectionContent">
          <h4
            ><a name="createdequal"
              >Not all vehicle history reports are created equal</a
            ></h4
          >
          <p
            ><strong
              >See why an Autocheck Report is superior to the bargain
              alternative</strong
            >
            <br />
            AutoCheck is a powerful vehicle history report that helps take the
            unknown out of the used car buying, so you can confidently
            understand, compare and select a vehicle that is right for you.
            Unlike other bargain reports, AutoCheck can help you identify the
            hidden information you need the most, including:</p
          >
          <ul>
            <li>Nationwide auction announcements, e.g. frame damage</li>
            <li>Reported accidents</li>
            <li>Service and maintenance records</li>
            <li>Lemon Vehicles</li>
            <li>Major title brands, e.g. flood damage</li>
          </ul>
          <p>&nbsp;</p>
          <p><img width="100%" alt="" src="images/ac-reports-comp-tbl.png"/></p>
          <p>&nbsp;</p>
          <p
            ><a name="score"
              ><strong
                >Only AutoCheck has the patented AutoCheck Score<sup
                  >®</sup
                ></strong
              ></a
            >
            to help you assess a vehicle's predicted reliability and compare it
            to similar cars in its class.</p
          >
          <p
            >Because we have vehicle information from all 50 states, as well as
            auction and accident data from many public and private sources,
            AutoCheck provides you a value not found in the bargain reports.</p
          >
          <p
            ><BaseLink :to="{ name: 'reports-list' }"
              ><b
                >Purchase AutoCheck<sup>®</sup> vehicle history reports today!
                &gt;&gt;</b
              ></BaseLink
            ></p
          >
        </div>
        <VehicleSearch />
      </div>
      <div class="col-md-3 col-12">
        <div class="content-page-right-navigation gray">
          <h4>AutoCheck vs. Other Reports</h4>
          <ul>
            <li
              ><a href="#createdequal"
                >How does AutoCheck beat the other reports</a
              ></li
            >
            <li
              ><a href="#score">The patented AutoCheck Score<sup>®</sup></a></li
            >
            <li
              ><BaseLink :to="{ name: 'reports-list' }"
                >Get an AutoCheck report</BaseLink
              ></li
            >
          </ul>
        </div>
        <div class="mt-1">
          <a v-scroll-to="'#searchVin'" href="#"
            ><img class="w-80 m-auto d-block" src="images/ac-check-vin.png"
          /></a>
        </div>
      </div>
    </div>
  </Layout>
</template>
